import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import { getErrors, getResData } from "../../shared/utility";

// Get Categories
export const getLocationStart = () => {
  return {
    type: actionTypes.GET_LOCATION_START,
  };
};

export const getLocationSuccess = (locations: any) => {
  return {
    type: actionTypes.GET_LOCATION_SUCCESS,
    locations,
  };
};

export const getLocationFailed = (error: any) => {
  return {
    type: actionTypes.GET_LOCATION_FAIL,
    error,
    locations: null,
  };
};

export const getLocation = (data: any={"pageSize": 1000,"start": 0}) => {
  return async (dispatch: any) => {
    dispatch(getLocationStart());

    return axios
      .post(`/locations` , data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);          
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getLocationSuccess(data.data));
        }
      })
      .catch((err) => dispatch(getLocationFailed(getErrors(err))));
  };
};